const mutations = {
    SetIdMainGroup: (state, payload) => {
        state.id_main_group = payload;
    },
    SetGroup: (state, payload) => {
        state.groups = payload;
    },
    SetGroupUser: (state, payload) => {
        state.groupsUser = payload;
    },
    SetVolume:(state, payload) => {
        state.volumes = payload;
    },
    SetSubgroup:(state, payload) => {
        state.subgroup = payload;
    },
    SetSubgroupUser:(state, payload) => {
        state.subgroupUser = payload;
    },    
    SetLanguage:(state, payload) => {
        state.language = payload;
    },
    SetRole:(state, payload) => {
        state.roles = payload;
    },
    SetModalImportUsers: state => {
        state.openModalImportUsers = !state.openModalImportUsers;
    },
    SetModalSupport: state => {
        state.openModalSupport = !state.openModalSupport;
    },
    SetModalActiveVolumen: state => {
        state.openModalActiveVolumen = !state.openModalActiveVolumen;
    },
    SetModalImportsubgroup: state => {
        state.ModalImportSubgroup = !state.ModalImportSubgroup;
    },
    SetModalImportUsersSubGroup: state => {
        state.ModalImportUserSubGroup = !state.ModalImportUserSubGroup;
    },
    SetModalImportUsersGroup: state => {
        state.ModalImportUserGroup = !state.ModalImportUserGroup;
    },
};
export default mutations;